import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

import Layout from '@/layout';
import mainChildren from './modules/main.js';
//备案
// import filings from './modules/filings.js';
//电影
import film from './modules/film.js';
//本地生活
import local from './modules/local.js';

let routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    hidden: true,
    children: mainChildren
  },{
    path: '/home',
    name: 'home',
    component: () => import('@/views/index/home.vue'),
    meta: {
      title: '首页'
    }
  },
  // ...filings,
  ...film,
  ...local
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
